import React, { useEffect, useState } from "react";
import "./header_LB_gri.css";
// import lib_bl from '../../../assets/img/LibroBl2.png';
import lib_bl from "../../../assets/imgs/nuevo_libro/Image.png";
import { useTranslation } from "react-i18next";
import NL_descarga_line from "../../../assets/imgs/nuevo_libro/NL_descargar_line.png";
import NL_descarga_line2 from "../../../assets/imgs/nuevo_libro/Arrow.png";

// import idea_mov from '../../assets/img/ideas_mov.png';

const Header_LB_gri = () => {
  const [lang, setLang] = useState(localStorage.getItem("language") || "es");
  const [langText, setLangText] = useState(
    lang === "es" ? "English" : "Español"
  );
  const [t, i18n] = useTranslation("librBlanc");

  return (
    <div class="NL_header">
      <div class="NL_titulo">
        {/* <h1>{(t('header.idea'))} */}
        <p>
          {t("header.idea")}
          {/* Ideas sobre la  */}
          {/* <span class="NL_txt_naranja"> {(t('header.sobre'))} <br class="saltito"  /> */}
          <span class="NL_txt_naranja">
            {t("header.sobre")}
            {/* que cambian al mundo</span> */}
          </span>
          {/* </h1> */}
        </p>
        <p>
          {/* <span class="NL_txt_naranja">  */}
          <span class="NL_txt_naranja2">
            {/* {(t('header.sobre'))}  */}
            {/* que cambian al mundo</span> */}
            {t("header.cambi")}
          </span>
        </p>
      </div>
      <div class="NL_parrafo_heade">
        <p>
          {t("header.conoce")} <br class="saltito"></br>
          <br />
        </p>
      </div>
      <div class="NL_parrafo2">
        <p>
          {t("header.liber")} {t("header.liber2")}
          <b>
            <i> {t("header.ideas")}</i>{" "}
          </b>
          {t("header.liber3")}
          {t("header.cierraAdmin")}
        </p>
      </div>

      <div class="NL_compra_line ">
        <img src={NL_descarga_line2} />
      </div>


      {i18n.language == 'es' ? (
        <>
          <div class="btn btn-esp">
            <a
              href="https://www.amazon.com.mx/Ideas-Sobre-Libertad-Cambian-Mundo/dp/6079900653/ref=sr_1_2?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&keywords=ideas+sobre+la+libertad&qid=1678383847&sr=8-2"
              target="_blank"
            >
              <button class="btn_compra">{t("header.compra")}</button>
            </a>
          </div>
        </>) : (
        <>
          <div class="btn">
            <a
              href="https://www.amazon.com.mx/dp/B0DN7DNTWT?ref=cm_sw_r_cso_wa_apan_dp_BZF1C4P3T9BVYJ7XRF3F&ref_=cm_sw_r_cso_wa_apan_dp_BZF1C4P3T9BVYJ7XRF3F&social_share=cm_sw_r_cso_wa_apan_dp_BZF1C4P3T9BVYJ7XRF3F&skipTwisterOG=1"
              target="_blank"
            >
              <button class="btn_compra">{t("header.compra")}</button>
            </a>
          </div>
        </>
      )}


      <div class="div_bot_NL ">
        <a class="but_NL" href="#" />
      </div>

      <div class="NL_img">
        {/* <img src='\assets\imgs\nuevo_libro\header_libroVerde.png'/> */}
        {i18n.language == 'es' ? (
          <img src={lib_bl} />
        ) : (
          <img src='https://www.ricardosalinas.com/images/Portada-Libro-Blanco-RBS_ingles-all.png' />
        )}
      </div>
    </div>
  );
};

export default Header_LB_gri;
// NL_descarga_txt1_edit

// NL_descarga_txt1_regitro
// NL_descarga_txt1
